export enum ListType {
  ARCHIVED = 'archived',
  ACTIVE = 'active',
}
